/** @format */

import React, { useState } from "react";
import { toast } from "react-toastify";
import "./index.scss";
import { IconButton } from "@mui/material";
import { invokeUploadFile } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { Icon } from "@iconify/react";

const SiFileUpload = ({ title, clsName, url, callBack, id, fileTypes, multiple }) => {
  const [files, setFiles] = useState([]);
  const [uploadStatus, setUploadStatus] = useState("");

  const onFormSubmit = (e) => {
    e.preventDefault();
    fileUpload();
  };

  const onChange = (e) => {
    if (multiple) {
      setFiles(Array.from(e.target.files));
    } else {
      setFiles(e.target.files[0] ? [e.target.files[0]] : []);
    }
  };

  const fileUpload = () => {
    const formData = new FormData();
    files.forEach((f) => formData.append("upload", f));
    setUploadStatus("Uploading...");
    const apiUrl = url ? url : `${HOSTNAME}${REST_URLS.UPLOAD_FILES}${id}`;
    return invokeUploadFile(apiUrl, formData)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Uploaded Successfully");
          setFiles([]);
          setUploadStatus("");
          if (multiple && Array.isArray(response.data)) {
            const result = response.data.map((f) => ({ ...f, url: f.url?.split("?")[0] }));
            callBack && callBack(result);
          } else {
            const uploadedUrl = response.data.url?.split("?")[0];
            callBack && callBack({ ...response.data, url: uploadedUrl });
          }
        } else {
          toast.error(
            (response.data && response.data.message) || "Upload Failed"
          );
          setUploadStatus("");
          setFiles([]);
        }
      })
      .catch((err) => {
        toast.error("Upload Failed");
        setUploadStatus("");
        setFiles([]);
      });
  };

  const hasFiles = files.length > 0;
  const fileLabel = multiple && files.length > 1
    ? `${files.length} files selected`
    : files[0]?.name || "";

  return (
    <form className={`spidle-upload-file ${clsName}`}>
      {!hasFiles ? (
        <IconButton
          title="Attach file"
          size="small"
          style={{
            background: "#001A53",
            color: "#fff",
            borderRadius: "6px",
            minWidth: "150px",
            fontSize: "13px",
            cursor: "pointer",
            padding: 9,
          }}
        >
          <label
            htmlFor={title ? "file-upload-with-type" : "file-upload"}
            className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary upload-button"
          >
            <Icon
              icon="solar:upload-bold-duotone"
              width="1.2em"
              height="1.2em"
            />
            {title ? title : " Upload Documents"}
          </label>
        </IconButton>
      ) : (
        <label title={fileLabel} className="uploaded-file-name">
          {fileLabel}
        </label>
      )}
      <input
        id={title ? "file-upload-with-type" : "file-upload"}
        type="file"
        multiple={!!multiple}
        accept={
          fileTypes
            ? Array.isArray(fileTypes)
              ? fileTypes.join(",")
              : fileTypes
            : "*"
        }
        onChange={(event) => {
          onChange(event);
          event.target.value = null;
        }}
      />
      {hasFiles && (
        <span>
          <IconButton
            color="primary"
            onClick={onFormSubmit}
            title="Upload"
            disabled={uploadStatus}
          >
            <Icon
              icon="ant-design:check-circle-twotone"
              width="1.5rem"
              height="1.5rem"
              style={{ color: "#529e29" }}
            />
          </IconButton>
          <IconButton
            color="primary"
            onClick={() => setFiles([])}
            title="Clear"
            disabled={uploadStatus}
          >
            <Icon
              icon="ic:twotone-cancel"
              width="1.5rem"
              height="1.5rem"
              style={{ color: "#c83232" }}
            />
          </IconButton>
        </span>
      )}
      {uploadStatus}
    </form>
  );
};

export default SiFileUpload;
